import { render, staticRenderFns } from "./button-component.vue?vue&type=template&id=4ee8580f&scoped=true"
import script from "./button-component.vue?vue&type=script&lang=js"
export * from "./button-component.vue?vue&type=script&lang=js"
import style0 from "./button-component.vue?vue&type=style&index=0&id=4ee8580f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee8580f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ee8580f')) {
      api.createRecord('4ee8580f', component.options)
    } else {
      api.reload('4ee8580f', component.options)
    }
    module.hot.accept("./button-component.vue?vue&type=template&id=4ee8580f&scoped=true", function () {
      api.rerender('4ee8580f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/compoment/button-component/button-component.vue"
export default component.exports